<script lang="ts">
import { defineComponent, ref } from 'vue'
import TemplateSolutionFormLp from '@/components/_core/TemplateSolutionFormLp.vue'
import DocumentMain from './Main.vue'
import DocumentBreadcrumb from './Breadcrumb.vue'
import type { Ref } from 'vue'

export default defineComponent({
  name: 'DocumentApp',

  components: {
    TemplateSolutionFormLp,
    DocumentMain,
    DocumentBreadcrumb,
  },

  setup() {
    const logoColor: Ref<'default' | 'white' | 'gray'> = ref('default')

    return {
      // data
      logoColor,
    }
  }
})
</script>

<template>
  <TemplateSolutionFormLp :logo-color="logoColor">
    <template #breadcrumbHeader>
      <DocumentBreadcrumb />
    </template>

    <template #main>
      <DocumentMain @init:logo-color="logoColor = $event" />
    </template>
  </TemplateSolutionFormLp>
</template>
